import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import {
    setDepthOfMaxDLS,
    setMaxDLSAboveKOP,
    setWellKOPOverride,
    setTransitionZone,
    setTailPipeLength,
    setTailPipeBottom,
    setTailPipeInsideTZ,
    setWellDataInMainReportFlag,
    setNotes,
    setLoading,
    setError
} from "../../../store/jetlift/jetlift-output/WellSurveySlice";

const useJetliftWellSurveyFacade = () => {
    const dispatch = useAppDispatch();


    const updateKOPOverride = async (payload: any) => {
        return await dispatch({ type: "jetlift/wellSurvey/setWellKOPOverride", payload });
    };
    const updateMaxDLSAboveKOP = async (payload: any) => {
        return await dispatch(setMaxDLSAboveKOP(payload));
    };
    const updateDepthOfMaxDLS = async (payload: any) => {
        return await dispatch(setDepthOfMaxDLS(payload));
    }
    const updateTransitionZone = async (payload: number) => {
        return await dispatch(setTransitionZone(payload));
    };

    const updateTailPipeLength = async (payload: number) => {
        return await dispatch(setTailPipeLength(payload));
    };

    const updateTailPipeBottom = async (payload: number) => {
        return await dispatch(setTailPipeBottom(payload));
    };

    const updateTailPipeInsideTZ = async (payload: number) => {
        return await dispatch(setTailPipeInsideTZ(payload));
    };
    const updateWellDataInMainReportFlag = async (payload: boolean) => {
        return await dispatch(setWellDataInMainReportFlag(payload));
    };

    const updateWellNotes = (payload: any) => {
        return dispatch(setNotes(payload));
    };

    const importWellSurveyData = (formData: FormData) => {
        dispatch(setLoading(true));
        dispatch({ type: "jetlift/wellSurvey/fetchData", payload: { inputData: formData } });
    };

    const getExistingWellSurveyData = (projectId?: string) => {
        dispatch({ type: "jetlift/wellSurvey/fetchExistingData", payload: { projectId } });
    };

    const clearWellSurveyData = (projectId?: string) => {
        dispatch({ type: "jetlift/wellSurvey/clearData", payload: { projectId } });
    };

    return {
        updateKOPOverride,
        updateMaxDLSAboveKOP,
        updateDepthOfMaxDLS,
        updateTransitionZone,
        updateTailPipeLength,
        updateTailPipeBottom,
        updateTailPipeInsideTZ,
        updateWellDataInMainReportFlag,
        updateWellNotes,
        importWellSurveyData,
        getExistingWellSurveyData,
        clearWellSurveyData
    };
};

export default useJetliftWellSurveyFacade;
